import { render, staticRenderFns } from "./ReadOnlyContributions.vue?vue&type=template&id=c3843932&scoped=true"
import script from "./ReadOnlyContributions.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyContributions.vue?vue&type=script&lang=ts"
import style0 from "./ReadOnlyContributions.vue?vue&type=style&index=0&id=c3843932&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3843932",
  null
  
)

export default component.exports